import * as R from 'remeda';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SchedulingService } from '@api/services';
import { Input } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { Globals } from '../../../../globals';
import { MeetingOccuranceListData, ListConfig } from '../../models/meeting-occurence-card.datasource';
import { dateBuilder } from '@core/models/date.model';
import { parseDateFormattedFromDate, parseTimeFormatted } from '@shared/models/date-formats.model';
import { BaseComponent } from '@shared/components/base/base.component';
import { TranslocoService} from '@jsverse/transloco';
import { MatTableDataSource} from "@angular/material/table";
import { Cf2MaterialModule} from "@modules/cf2-material/cf2-material.module";
import { RxFormBuilder} from "@rxweb/reactive-form-validators";

@Component({
  selector: 'cf2-meeting-occurance-card',
  templateUrl: './meeting-occurence-card.component.html',
  styleUrls: ['./meeting-occurence-card.component.scss'],
  imports: [
    Cf2MaterialModule,
  ],
  providers: [RxFormBuilder],
})
export class MeetingOccuranceCardComponent extends BaseComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Input() isReady = false;

  dataSub = new MatTableDataSource<any>();
  columnConfig: ListConfig[];
  columns: any;
  currentPath: string;
  resultCount: number;

  viewAppointment(meetingOccurrenceKey: number, meetingKey: number) {
    this.navigate('scheduling/view', {
      meetingOccurrenceKey,
      meetingKey,
    });
  }

  viewClient(clientKey: number, caseKey: number) {
    this.navigate('clients', { clientKey: clientKey, caseKey: caseKey });
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private globals: Globals,
    private schedulingSvc: SchedulingService, private translocoService: TranslocoService
  ) {
    super();
    if (this.route?.snapshot?.routeConfig?.path) {
      this.currentPath = this.route.snapshot.routeConfig.path;
    }

      const tableSetup = new MeetingOccuranceListData(translocoService);
      this.columnConfig = tableSetup.config;
      this.columns = this.columnConfig.map((column) => column.key);
  }

  ngOnInit(): void {
    this.dataSub.sort = this.sort;

    // Display all the meetings that are taking place in the next 24 hours
    const fromDate = parseDateFormattedFromDate(new Date(dateBuilder()[0], dateBuilder()[1], dateBuilder()[2]));
    const toDate = parseDateFormattedFromDate(new Date(dateBuilder()[0], dateBuilder()[1], (dateBuilder()[2] + 1)));

    this.schedulingSvc
      .apiSchedulingEmployeeParentEmployeeKeyGet$Json({
        parentEmployeeKey: this.globals.employeeKey,
        meetingStatusCode: 'SCHED',
        fromDate,
        toDate,
      })
      .subscribe((data) => {
        data.forEach((c) => {
          c.startISOFormatted = parseTimeFormatted(c.startISOFormatted);
          c.endISOFormatted = parseTimeFormatted(c.endISOFormatted);
          c.meetingDateFormatted = parseDateFormattedFromDate(new Date(c.meetingDate));
        })
        
        this.dataSub.data = data
        this.dataSub.sort = this.sort;
        this.resultCount = data?.length;
        setTimeout(() => {
          this.isReady = true;
        }, 100);
      });
  }
}
